import type { CallInfo } from '@compass/client/types/call';
import { useQuery } from '@tanstack/react-query';

import { callService } from '@/services/api';

/**
 * Hook to fetch the current user's active (in-progress) call.
 * Polls every 5 seconds to keep duration and status up to date.
 */
export function useActiveCall(enabled = true) {
  const query = useQuery({
    queryKey: ['myActiveCall'],
    queryFn: async () => {
      const response = await callService.getMyUserCalls({
        status: 'in_progress',
        type: 'external_call',
        limit: 1,
      });
      return (response.calls?.[0] ?? null) as CallInfo | null;
    },
    enabled,
    refetchInterval: 10000,
    staleTime: 10000,
  });

  return {
    activeCall: query.data ?? null,
    isLoading: query.isLoading,
  };
}
